import m from 'mithril'
import { adminAuth } from '../lib/api.js'

// Admin auth state — completely separate from user auth
let currentAdmin = null
let loading = false
let error = null

export const adminAuthModel = {
  get admin() { return currentAdmin },
  get loading() { return loading },
  get error() { return error },
  get isLoggedIn() { return !!currentAdmin },

  async init() {
    loading = true
    try {
      const result = await adminAuth.session()
      currentAdmin = result?.admin || null
    } catch {
      currentAdmin = null
    } finally {
      loading = false
      m.redraw()
    }
  },

  async login(email, password) {
    error = null
    try {
      const result = await adminAuth.login({ email, password })
      currentAdmin = result.admin
      m.route.set('/admin')
    } catch (err) {
      error = err.message
      m.redraw()
    }
  },

  async logout() {
    await adminAuth.logout()
    currentAdmin = null
    m.route.set('/admin/login')
  },

  clearError() {
    error = null
  },
}
